import { Link } from 'react-router-dom';

const services = [
  {
    title: 'Temporary Staffing',
    subtitle: 'We handle:',
    description: 'When your business needs fast, flexible, and reliable support - we\'re ready to deliver. We handle recruitment, screening, onboarding paperwork, and payroll for every temporary placement.',
    items: ['Fast Turnaround', 'Pre-Screened Candidates', 'Flexible Assignment Lengths', 'Hands-Off Administration'],
    icon: 'ri-time-line',
    tag: 'Flexible',
  },
  {
    title: 'Temp-to-Hire',
    subtitle: 'We handle:',
    description: 'Try before you commit. Find your next long-term team member with confidence. Our temp-to-hire model gives you the opportunity to evaluate a candidate\'s skills, work ethic, and cultural fit before extending a full-time offer.',
    items: ['Reduce Hiring Risk', 'Seamless Conversion', 'No Up-Front Commitment', 'Motivated Candidates'],
    icon: 'ri-briefcase-line',
    tag: 'Low Risk',
  },
];

export default function ServicesSection() {
  return (
    <section className="py-20 bg-[#f8f7f2]">
      <div className="max-w-6xl mx-auto px-8 md:px-14">

        {/* Header */}
        <div className="flex items-start gap-5 mb-16">
          <div className="w-1 bg-[#c8a84b] self-stretch rounded-full shrink-0" style={{ minHeight: '60px' }} />
          <div>
            <p
              className="text-[#c8a84b] text-xs font-bold tracking-[0.3em] uppercase mb-2"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              What We Offer
            </p>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-[#1a3a3a] leading-tight"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Our Staffing Services
              <br />
              <em className="not-italic text-[#c8a84b]">Built Around Your Needs</em>
            </h2>
          </div>
        </div>

        {/* Service cards — rack card checklist style */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {services.map((s) => (
            <div
              key={s.title}
              className="bg-white rounded-lg overflow-hidden border border-gray-100 hover:border-[#c8a84b]/40 transition-all duration-300 group"
            >
              {/* Card header */}
              <div className="bg-[#1a3a3a] px-7 py-5 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${s.icon} text-xl text-[#c8a84b]`} />
                  </div>
                  <h3
                    className="text-white font-bold text-base"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {s.title}
                  </h3>
                </div>
                <span
                  className="px-3 py-1 rounded-sm bg-[#c8a84b]/20 text-[#c8a84b] text-xs font-bold tracking-wide whitespace-nowrap"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {s.tag}
                </span>
              </div>

              {/* Card body */}
              <div className="px-7 py-6">
                <p
                  className="text-gray-500 text-sm leading-relaxed mb-5"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {s.description}
                </p>
                <p
                  className="text-[#1a3a3a] text-xs font-bold tracking-widest uppercase mb-3"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  {s.subtitle}
                </p>
                <ul className="space-y-2">
                  {s.items.map((item) => (
                    <li key={item} className="flex items-center gap-3">
                      <i className="ri-check-line text-[#c8a84b] text-base font-bold shrink-0" />
                      <span
                        className="text-sm text-[#1a3a3a] font-medium"
                        style={{ fontFamily: "'Inter', sans-serif" }}
                      >
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-md bg-[#1a3a3a] text-white text-sm font-bold tracking-wide hover:bg-[#0d2b2b] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            View All Services <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
